import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: () => import('../views/Calculator.vue')
  },
  {
    path: '/tablo',
    name: 'tablo',
    component: () => import('../views/Tablo.vue')
  },
  // Открываем краткий отчёт для диспетчера по текущей работе.
  {
    path: '/dispatcher',
    name: 'dispatcher',
    component: () => import('../views/Dispatcher.vue')
  },
  {
    path: '/gorbunova',
    name: 'gorbunova',
    component: () => import('../views/Gorbunova.vue')
  },
  // Открываем отдельную страницу с рецептами Горбуновой.
  {
    path: '/gorbunova/recept',
    name: 'gorbunova-recept',
    component: () => import('../views/Gorbunova.recept.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to, from, next) => {

  window.scrollTo({ top: 0, behavior: "smooth" });

  if ($("body").hasClass("sidebar-show")) {
    $("body").removeClass("sidebar-show");
  }

  if (!to.matched.length) {
    next('/404');
  } else {
    next();
  }
});

export default router
